module.exports = __webpack_public_path__ + "static/img/zhongzhongka19.2840b34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka19.png
// module id = FWZ8
// module chunks = 16